import { Component, ElementRef, ViewChild, inject, computed } from "@angular/core";
import { CommonModule } from "@angular/common";
import { Router, RouterModule } from "@angular/router";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { CreditOverviewComponent } from "@app/shared/payment/components/credit-overview/credit-overview.component";
import { ChatIconComponent } from "@app/shared/chat/components/chat-icon/chat-icon.component";
import { AuthServiceImpl } from "@app/shared/authentication/services/auth.servcice";
import { BackButtonComponent } from "@app/shared/general/components/back-button/back-button.component";
import { toSignal } from "@angular/core/rxjs-interop";
import { PropertySearchComponent } from "@app/core/filtering/components/property-search/property-search.component";
import { PropertyFiltersComponent } from "@app/core/filtering/components/property-filters/property-filters.component";
import { MenuComponent } from "@kernel/tools/menu/components/menu/menu.component";
import { MenuItemInterface } from "@kernel/tools/menu/interfaces/menu-item.interface";

@Component({
  selector: "app-top-nav",
  templateUrl: "./top-nav.component.html",
  styleUrls: ["./top-nav.component.scss"],
  imports: [
    CommonModule,
    RouterModule,
    TranslateModule,
    CreditOverviewComponent,
    ChatIconComponent,
    BackButtonComponent,
    PropertySearchComponent,
    PropertyFiltersComponent,
    MenuComponent,
  ],
})
export class TopNavComponent {
  private readonly translateService = inject(TranslateService);
  private readonly authService = inject(AuthServiceImpl);
  private readonly router = inject(Router);

  protected routerEvent = toSignal(this.router.events, { initialValue: null });
  protected isRootRoute = computed(() => this.routerEvent() && this.router.url === "/");

  @ViewChild("userMenu") userMenu!: ElementRef;
  @ViewChild("userAvatar") userAvatar!: ElementRef;

  displayFilters = false;

  userMenuItems: MenuItemInterface[] = [
    { icon: "pi pi-user", label: this.translateService.instant("topNav.actions.profile"), routerLink: "/profile" },
    { icon: "pi pi-credit-card", label: this.translateService.instant("topNav.actions.billing"), routerLink: "/payment/billing" },
    { icon: "pi pi-home", label: this.translateService.instant("topNav.actions.property"), routerLink: "/my-request/edit" },
    { icon: "pi pi-sign-out", label: this.translateService.instant("topNav.actions.logout"), command: () => this.logout() },
  ];

  toggleFilters() {
    this.displayFilters = !this.displayFilters;
  }

  async logout(): Promise<void> {
    this.authService.clearUser();
    await this.router.navigate(["/auth/login"]);
  }

  navigateToRoot() {
    return this.router.navigate(["/"]);
  }
}
